module.exports = __webpack_public_path__ + "img/phone-hang-up.a70fb372.svg";